import axios from "@/utils/axios";

export function couponActiveDetail(params: object) {
	return axios.post("/api/gateway/app/front/share/detail", params);
}
export function getGt4Captcha(params: object) {
	return axios.post("/api/gateway/app/front/share/initVerifyCaptcha", params);
}

export function getVerifyCode(params: object) {
	const config = {
		headers: {
			language: "en",
			serviceId: "h5",
		},
	};
	return axios.post("/api/gateway/app/front/share/verifyCode", params, config);
}

export function loginAndSend(params: object) {
	return axios.post("/api/gateway/app/front/share/coupon/loginAndSend", params);
}

/**
 * 领取优惠券
 * @param params
 * @returns
 * https://yapi.hdltest.com/project/2717/interface/api/169887
 */
export function shareCouponSend(params: object) {
	return axios.post("/api/gateway/app/front/share/coupon/sendNoLogin", params);
}

// 券列表
const couponList = (params: object) => {
	// return axios.post('/activity/front/receive/center/couponList', params);
	return axios.post("/activity/v1/receiveCouponCenter/couponList", params);
};
//发券
const sendCoupon = (params: object) => {
	// return axios.post('/activity/front/receive/center/sendCoupon', params);
	return axios.post("/activity/v1/receiveCouponCenter/sendCoupon", params);
};
//领券
const gainCoupon = (params: object) =>
	axios.post("/activity/private/gainCoupon", params);
//黑海转增礼
const forwardBlackMemberGiftCoupon = (params: object) =>
	axios.post(
		"/activity/v1/receiveCouponCenter/forwardBlackMemberGiftCoupon",
		params,
	);

//app 券包 未使用
const getCouponList = (marker: string = "") => {
	const params = {
		limit: 10,
		marker,
	};
	return axios.post("/app/card/getCouponList", params);
};

//app 券包已使用
const getUsedCouponList = (marker: string = "") => {
	const params = {
		limit: 10,
		marker,
	};
	return axios.post("/app/card/getUsedCouponList", params);
};
//app 券包已过期
const getExpiredCouponList = (marker: string = "") => {
	const params = {
		limit: 10,
		marker,
	};
	return axios.post("/app/card/getExpiredCouponList", params);
};
//app 券包 数量
const getCouponNum = (status: number) => {
	const params = {
		status,
	};
	return axios.post("/app/card/getCouponNum", params);
};
// app 券详情
const getCouponByCode = (couponCode: string) => {
	const params = {
		couponCode,
	};
	return axios.post("/app/card/getCouponByCode", params);
};
// app 券分享连接
const getCouponShareLink = (couponCode: string) => {
	const params = {
		couponCode,
	};
	return axios.post("/app/card/getCouponShareLink", params);
};
// app 券分享连接
const addCard = (cardId: string) => {
	const params = {
		code: cardId,
		country: "CN",
	};
	return axios.post("/app/coupon/bindCoupon", params);
};

//请求微信太阳码
const GetQrcode = (params: { wxParam?: object; scene?: string }): any =>
	axios.post("/activity/v1/receiveCouponCenter/getWxAppletQrCode", params);

export {
	gainCoupon,
	couponList,
	sendCoupon,
	getCouponList,
	getUsedCouponList,
	getExpiredCouponList,
	getCouponNum,
	getCouponByCode,
	getCouponShareLink,
	addCard,
	forwardBlackMemberGiftCoupon,
	GetQrcode,
};
